<template>
  <div class="content">
    <a-button icon="left" style="background-color: transparent; border-radius: 20px;" @click="blank">返回</a-button>
    <div class="header">
      <div class="title">
        答题进度完成：1/10  距离考核结束剩余：{{ countDown }}
      </div>
      <a-button type="primary" @click="submit">提交</a-button>
    </div>
    <div class="main">
      <div class="item">
        <div class="topic">
          <div class="title">单选题：1.下列哪一种中药材具有清热解毒的功效？（2分）</div>
          <div class="title1">
            <span>A. 人参 </span>
            <span>B. 黄连</span>
            <span>C. 白术</span>
            <span>D. 杏仁</span>
          </div>
        </div>
        <div class="answer">
          <a-radio-group :options="answerOptions1" />
        </div>
      </div>
      <div class="item">
        <div class="topic">
          <div class="title">单选题：1.下列哪一种中药材具有清热解毒的功效？（2分）</div>
          <div class="title1">
            <span>A. 人参 </span>
            <span>B. 黄连</span>
            <span>C. 白术</span>
            <span>D. 杏仁</span>
          </div>
        </div>
        <div class="answer">
          <a-checkbox-group :options="answerOptions2" />
        </div>
      </div>
      <div class="item">
        <div class="topic">
          <div class="title">填空题：3.中药名中的空白：___参益气丸。（2分）</div>
        </div>
        <div class="answer">
          <div class="input">(1) <a-input placeholder="请输入答案" /></div>
          <div class="input">(2) <a-input placeholder="请输入答案" /></div>
          <div class="input">(3) <a-input placeholder="请输入答案" /></div>
        </div>
        <div class="topic">
          <div class="title">4.中药名中的空白：___参益气丸。（2分）</div>
        </div>
        <div class="answer">
          <div class="input">(1) <a-input placeholder="请输入答案" /></div>
        </div>
      </div>
      <div class="item">
        <div class="topic">
          <div class="title">
            解答题：下列哪一种中药材具有清热解毒的功效，下列哪一种中药材具有清热解毒的功效，下列哪一种中药材具有清热解毒的功效，下列哪一种中药材具有清热解毒
            的功效参益气丸下列哪一种中药材具有清热解毒的功效，下列哪一种中药材具有清热解毒的功效，下列哪一种中药材具有清热解毒的功效，下列哪一种中药
            材具有清热解的功效参益。
          </div>
          <div class="images">
            <img src="@/assets/img/medicine1.jpg" alt="">
            <img src="@/assets/img/medicine2.jpg" alt="">
          </div>
        </div>
        <div class="textarea1">
          <a-textarea
            placeholder="请输入答案"
            :auto-size="{ minRows: 2, maxRows: 6 }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 设置倒计时时长(单位:秒)
const countdownDuration = 600

export default {
  name: 'PtExamine',

  data() {
    return {
      answerOptions1: [
        { label: 'A', value: 'A' },
        { label: 'B', value: 'B' },
        { label: 'C', value: 'C' },
        { label: 'D', value: 'D' }
      ],
      answerOptions2: [
        { label: 'A', value: 'A' },
        { label: 'B', value: 'B' },
        { label: 'C', value: 'C' },
        { label: 'D', value: 'D' }
      ],
      countDown: '10:00'
    }
  },

  mounted() {
    this.countDownFn()
  },

  methods: {
    blank() {
      this.$router.push({ name: 'theoryCheck' })
    },
    submit() {
    },
    countDownFn() {
      let remainingTime = countdownDuration
      this.countdownInterval = setInterval(() => {
        // 初始化倒计时时间
        // 更新倒计时时间
        remainingTime--
        // 格式化倒计时时间为MM:SS格式
        const minutes = Math.floor(remainingTime / 60)
        const seconds = remainingTime % 60
        const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

        this.countDown = formattedTime
        if (remainingTime === 0) {
          clearInterval(this.countdownInterval)
        }
      }, 1000)
    }
  },
  destroyed() {
    clearInterval(this.countdownInterval)
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 26px 19px;
  margin-bottom: 30px;
  height: auto !important;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 0;
    font-size: 18px;
    font-weight: bold;
    color: #545A61;
  }
  .main {
    .item {
      border: solid 1px #E6E7EB;
      margin-bottom: 22px;
      border-radius: 5px;
      .topic {
        background: #F8FAFC;
        padding: 21px;
        color: #000;
        .title {
          font-weight: bold;
          font-size: 16px;
        }
        .title1 {
          margin-top: 5px;
          margin-left: 66px;
          font-size: 14px;
          span {
            padding-right: 15px;
          }
        }
        .images {
          margin-top: 15px;
          margin-left: 66px;
          img {
            width: 260px;
            height: 150px;
            padding-right: 30px;
          }
        }
      }
      .answer {
        display: flex;
        margin:22px 88px;
        .input {
          display: flex;
          align-items: center;
          width: 33%;
          margin-right: 2%;
          /deep/ .ant-input {
            border: none;
            border-bottom: solid 1px #E6E7EB;
            box-shadow: none;
            border-radius: 0;
          }
        }
      }
      .textarea1 {
        margin:30px 86px;
      }
    }
  }
}
</style>
